export default __webpack_public_path__ + "static/media/plate_check.c5c3fc32.svg";